import type { ExtractPropTypes } from 'vue'
import type Backtop from './backtop.vue'

export const backtopProps = {
  visibilityHeight: {
    type: Number,
    default: 240,
  },
  target: {
    type: String,
    default: '',
  },
  right: {
    type: Number,
    default: 24,
  },
  bottom: {
    type: Number,
    default: 24,
  },
} as const
export type BacktopProps = ExtractPropTypes<typeof backtopProps>

export const backtopEmits = {
  click: (evt: MouseEvent) => evt instanceof MouseEvent,
}
export type BacktopEmits = typeof backtopEmits

export type BacktopInstance = InstanceType<typeof Backtop>
